module.exports = __webpack_public_path__ + "static/media/KW900-02-15.8aa931c9.jpg";